import { P2GBox } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

type props = {
  children: ReactNode;
  selected?: boolean;
  variant:
    | 'extra'
    | 'address'
    | 'protection'
    | 'shop'
    | 'label'
    | 'marketplace'
    | 'ddp-option'
    | 'sender-type'
    | 'upgrade'
    | 'add-again'
    | 'multi-address'
    | 'code-suggestion'
    | 'code-suggestion-wrapper';
  dataTestId?: string;
  onClick?: () => void;
  translations?: Record<string, string>;
};

const useStyles = (translations: Record<string, string> | undefined) =>
  makeStyles()((theme) => ({
    container: {
      cursor: 'pointer',
      position: 'relative',
      border: `1px solid ${theme.palette.primary.light}`,
      paddingLeft: theme.spacing(2),
      borderRadius: theme.shape.borderRadius * 2,
      transition: 'all 0.1s',
      zIndex: 2,
      '&:hover': {
        outline: `1px solid ${theme.palette.primary.main}`
      },
      '&.selected': {
        outlineOffset: '-3px',
        outline: `3px solid ${theme.palette.primary.main}`
      },
      '&.p2g-option-extra': {
        padding: theme.spacing(3),
        borderLeft: `8px solid ${theme.palette.primary.main}`,
        '&:hover': {
          outline: 'none'
        }
      },
      '&.p2g-option-protection, &.p2g-option-label, &.p2g-option-sender-type': {
        padding: theme.spacing(2)
      },
      '&.p2g-option-marketplace': {
        padding: theme.spacing(1)
      },
      '&.p2g-option-add-again': {
        padding: theme.spacing(1)
      },
      '&.p2g-option-ddp-option': {
        padding: theme.spacing(1, 1, 1, 2)
      },
      '&.p2g-option-multi-address': {
        padding: theme.spacing(1, 1, 1, 2)
      },
      '&.p2g-option-code-suggestion': {
        padding: theme.spacing(1)
      },
      '&.p2g-option-code-suggestion-wrapper': {
        padding: theme.spacing(1.5)
      },
      '&.p2g-option-address': {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
      },
      '&.p2g-option-shop': {
        padding: theme.spacing(1)
      },
      '&.p2g-option-upgrade': {
        padding: theme.spacing(2),
        border: `3px solid ${theme.palette.primary.main}`,
        borderLeft: `8px solid ${theme.palette.primary.main}`,

        '&:hover': {
          outline: 'none'
        }
      },
      '& .recommended': {
        '::before': {
          content: `"${translations?.recommendedText}"`,
          color: theme.palette.common.white,
          borderTopLeftRadius: theme.spacing(0.5),
          borderTopRightRadius: theme.spacing(0.5),
          position: 'absolute',
          bottom: 'calc(100% + 1px)',
          left: '15px',
          zIndex: -1,
          padding: theme.spacing(0.5),
          paddingLeft: theme.spacing(1.5),
          paddingRight: theme.spacing(1.5),
          backgroundColor: theme.palette.secondary.main,
          borderBottom: '0',
          backgroundClip: 'padding-box',
          textTransform: 'uppercase'
        }
      },
      '& .MuiFormControlLabel-asterisk': {
        display: 'none'
      }
    }
  }));

const P2GOptionContainer: React.FC<props> = ({ translations, onClick, children, selected, variant, dataTestId }) => {
  const { classes } = useStyles(translations)();
  return (
    <P2GBox
      onClick={onClick}
      dataTestId={dataTestId}
      classNames={[classes.container, selected ? 'selected' : '', `p2g-option-${variant}`]}
    >
      {children}
    </P2GBox>
  );
};
export default P2GOptionContainer;
